export default function Helpers() {
  const isImage = image => /(jpg|jpeg|png|svg)/.test(image)

  return { isImage }
}
